import styled from '@emotion/styled'
import { Button } from '../../../../../buttons/Button/Button'
import { ButtonLink } from '../../../../../buttons/ButtonLink/ButtonLink'
import { colors } from '../../../../../__styling/settings/colors'
import { calcRem } from '../../../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../../../__styling/themed-value'

export const StyledRegistrationWallForm = styled('form')(({ theme }) => ({
    display: 'flex',
    flexBasis: calcRem(300),
    flexShrink: 1,
    flexGrow: 1,
    flexDirection: 'column',
    alignContent: 'center',
    alignSelf: 'center',
    padding: calcRem(theme.margins.md),
    margin: calcRem(0, theme.margins.lg),
    fontFamily: theme.fonts.sansSerif,
    borderRadius: 4,
    backgroundColor: colors.white,
    color: themedValue(theme, {
        thewest: colors.thewest.greyGorilla,
        fallback: 'currentColor',
    }),
    boxShadow: `0 4px 9px 0 ${colors.black25}`,
}))

export const StyledLabel = styled('label')(({ theme }) => ({
    display: 'block',
    fontSize: calcRem(19),
    fontWeight: 600,
    margin: calcRem(0, 0, theme.margins.sm, 0),
}))

export const StyledInput = styled('input')(({ theme }) => ({
    width: '100%',
    border: 'none',
    backgroundColor: themedValue(theme, {
        thewest: colors.thewest.greyMouse,
        sevennews: colors.sevennews.alto,
        perthnow: colors.perthnow.greyPyrite,
    }),
    fontFamily: theme.fonts.serif,
    fontSize: calcRem(16),
    padding: calcRem(13),
    marginBottom: calcRem(theme.margins.sm),

    '&:disabled': {
        pointerEvents: 'none',
        cursor: 'not-allowed',
        opacity: 0.5,
    },
}))

export const StyledRegisterButton = styled(Button)(({ theme }) => ({
    alignSelf: 'center',
    margin: calcRem(theme.margins.sm, 0, theme.margins.md, 0),
}))

export const StyledButtonLink = styled(ButtonLink)({
    display: 'block',
    fontSize: calcRem(14),
})

export const LoginText = styled('span')({ fontWeight: 600 })

export const StyledRegistrationResponse = styled('p')(({ theme }) => ({
    fontSize: calcRem(14),
    margin: calcRem(theme.margins.md, 0, 0, 0),
    textAlign: 'center',
}))

export const StyledTermsPrivacyText = styled('p')(({ theme }) => ({
    fontSize: calcRem(14),
    margin: calcRem(0, 0, theme.margins.md, 0),
    textAlign: 'center',
}))
